var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCellSignalNone = function SvgIconCellSignalNone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.648 2.346a1.75 1.75 0 0 1 2.102 1.712V19.5A1.75 1.75 0 0 1 18 21.25H2.558a1.75 1.75 0 0 1-1.229-2.994L16.756 2.83a1.75 1.75 0 0 1 .892-.483m.102 2.318V19.25H3.164z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCellSignalNone;